<template>
  <div v-if="!loading" class="form-group">
    <label :for="elementId" class="control-label">Video</label>
    <select :id="elementId" v-model="videoId"
            class="form-control" name="video"
            style="width: 100%;"></select>
  </div>
</template>

<script setup>
import {ref, onMounted} from 'vue'
import Video from '../../common/video'
const props = defineProps({
  idIndex: String,
  videoId: String
})

const emit = defineEmits(['handleChange'])
const loading = ref(true)

const videoId = ref(props.videoId || null)

const elementId = ref((props.idIndex) ? `video-select-${props.idIndex}` : 'video-select')

async function fetchVideos() {
  const videoClient = new Video()
  let resp = await videoClient.getVideos()
  let videos = resp.map(item => ({
    id: item.id,
    text: item.title
  }))

  if (videos.length === 1) {
    videoId.value = videos[0].id
  }
  loading.value = false
  console.log(videos)
  return videos
}

onMounted(async () => {
  const videos = await fetchVideos()

  console.log(props.videoId)

  $(() => {
    const $selectEl = $(`#${elementId.value}`)
    const data = _.map(videos, video => ({
      id: video.id,
      text: video.text,
      selected: video.id === videoId.value
    }))
    $selectEl.select2({
      data: data
    }).on('change', function () {
      let selected = $selectEl.select2('data')
      //console.log(selected)
      emit('handleChange', selected[0].id)
      videoId.value = selected[0].id
    })
  })

  if (videoId.value) {
    emit('handleChange', videoId.value)
  }
})
</script> 